import axios from 'axios';

const apiUrl = process.env.BACKEND_ENDPOINT;

export interface CatalogSuspension {
  enabled: boolean;
  startDate: string;
  endDate?: string;
  message: string;
}

export interface Catalog {
  type: string;
  title: string;
  slug: string;
  description: string;
  tags: string[];
  isFree: boolean;
  isOnline: boolean;
  isDigital?: boolean;
  category: string;
  targets: string[];
  department: string;
  departmentSections: string[];
  categorySlug: string;
  highlighted: boolean;
  score: number;
  imageUrl: string;
  icon: string;
  link: string;
  resultTotal: number;
  averageRatings?: { count: number; average: number };
  avgRating?: string;
  totalReviews?: number;
  suspension?: CatalogSuspension;
}

interface params {
  query?: string;
  category?: string[];
  departmentSlug?: string[];
  from?: number;
  size?: number;
  max?: number;
  isOnline?: boolean;
}

export async function search({
  query,
  category,
  departmentSlug,
  from,
  size,
  max,
  isOnline,
}: params): Promise<Catalog[]> {
  const response = await axios.post(`${apiUrl}/v1/search`, {
    query,
    groups: ['CATALOG'],
    category,
    departmentSlug,
    isOnline,
    from,
    size: size || max,
    sortField: 'title',
    sortOrder: 'asc',
  });

  return response.data;
}

export async function getTop10Catalogs(): Promise<Catalog[]> {
  const response = await axios.post(`${apiUrl}/v1/search/catalog-hybrid`, {
    query: '',
    groups: ['CATALOG'],
    from: 0,
    size: 15,
    sortField: 'title',
    sortOrder: 'asc',
  });

  return response.data?.highlight ?? [];
}
